var $export = require('./_export');
var $task = require('./_task');
$export($export.G + $export.B, {
  setImmediate: $task.set,
  clearImmediate: $task.clear
});



//////////////////
// WEBPACK FOOTER
// /opt/jenkins_home/workspace/marketing-campaigns_deploy_trigger_imp/3203/lib/node_modules/@core/macys-cli/node_modules/core-js/modules/web.immediate.js
// module id = 332
// module chunks = 0